// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"3e3931e7","455":"1d5bfcaa","718":"94d3439a"}[chunkId] + ".chunk.js";
};